<div>
  <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
  <div class="input-group">
    <input type="text" class="form-control" [placeholder]="placeholder || ''" [(ngModel)]="value" [id]="identifier" [disabled]="disabled"
      (input)="onInput()" />
    <validation [elementBase]="this"></validation>
    <div class="input-group-addon">
      <span class="glyphicon glyphicon-search"></span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵh.html